// src/pages/AboutUs.js
import React from "react";
import aboutImage from "../assets/Proalgenix Logo.svg"; // Replace with a relevant image

const AboutUs = () => {
  return (
    <div className="w-full bg-gray-900 text-white">
      {/* About Us Section */}
<section id="about" className="pt-12 sm:pt-20 pb-4 sm:pb-6 px-4 sm:px-8 lg:px-20 text-center">
  <h2 className="text-4xl sm:text-5xl font-bold mb-6">About Us</h2>
  <p className="text-lg sm:text-xl leading-relaxed text-justify">
    Proalgenix is a privately held biotechnology company pioneering the use of microalgae to develop next-generation microbial products and sustainable solutions for climate resilience. With deep expertise in algal and microbial genetics, we bridge the gap between research and real-world application. Our innovations span food, animal feed, biostimulants, wastewater treatment, and low-carbon biofuels. Harnessing India’s abundant year-round sunlight, we are scaling microalgae cultivation through open raceway ponds and photobioreactors to drive a greener, more sustainable future. 
  </p>
</section>

      {/* Our Objective Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-8 lg:px-20 bg-gray-900 border-t border-gray-700">
        <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-center">Our Objective</h2>
        <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-8 text-left">
          <img
            src={aboutImage}
            alt="Illustration representing Proalgenix's sustainable mission"
            className="w-40 sm:w-52 md:w-64 object-contain rounded-lg shadow-lg"
          />
          <div className="flex-1">
            <p className="text-lg sm:text-xl leading-relaxed text-justify text-gray-200">
              Our objective is to provide our products with affordable and available to all those who want to take delight in the high nutritional value microalgae that we responsibly produce in an environmentally friendly way.
            </p>
          </div>
        </div>
      </section>

      {/* Our Vision Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-8 lg:px-20 bg-gray-800 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-6">Our Vision</h2>
        <p className="text-lg sm:text-xl max-w-5xl mx-auto leading-relaxed text-justify text-gray-200">
          To integrate the green and blue economies in order to sustainably meet the
          world's growing demand for microalgae-based solutions.
        </p>
      </section>

      {/* Our Principles Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-8 lg:px-20">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8">Our Principles</h2>

        <div className="max-w-5xl mx-auto grid gap-12 sm:grid-cols-2 lg:grid-cols-3">
          {/* Passion */}
          <div className="text-left sm:text-center">
            <h3 className="text-2xl font-semibold text-green-400 mb-4">Passion</h3>
            <ul className="text-lg list-disc list-inside space-y-2 text-justify text-gray-200">
              <li>Advancing microalgae research to real-world applications.</li>
              <li>Commitment to employee well-being and safety.</li>
              <li>Building strong partnerships with clients and suppliers.</li>
              <li>Embracing constructive feedback for continuous growth.</li>
            </ul>
          </div>

          {/* Transparency */}
          <div className="text-left sm:text-center">
            <h3 className="text-2xl font-semibold text-blue-400 mb-4">Transparency</h3>
            <ul className="text-lg list-disc list-inside space-y-2 text-justify text-gray-200">
              <li>Fostering trust with stakeholders and business partners.</li>
              <li>Open facility visits to showcase operations.</li>
              <li>Clear and honest communication with all partners.</li>
              <li>Third-party verification of product quality.</li>
            </ul>
          </div>

          {/* Sustainability */}
          <div className="text-left sm:text-center">
            <h3 className="text-2xl font-semibold text-yellow-400 mb-4">Sustainability</h3>
            <ul className="text-lg list-disc list-inside space-y-2 text-justify text-gray-200">
              <li>Preserving ecological balance for future generations.</li>
              <li>Promoting social sustainability and local employment.</li>
              <li>Optimizing processes for energy efficiency.</li>
              <li>Implementing circular economy principles.</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
